import axios from "axios";

export const defaultGenderOptions = [
  { label: "Man", value: "MALE" },
  { label: "Woman", value: "FEMALE" },
  { label: "Other", value: "OTHER" },
];

export const defaultSearchPreferenceOptions = [
  { label: "Man", value: "MALE" },
  { label: "Woman", value: "FEMALE" },
  { label: "Both", value: "BOTH" },
];

const normalizeOptions = (options, fallback) => {
  if (!Array.isArray(options)) return fallback;
  const normalized = options
    .map((option) => ({
      label: String(option?.label || option?.value || "").trim(),
      value: String(option?.value || "").trim().toUpperCase(),
    }))
    .filter((option) => option.label && option.value);
  return normalized.length ? normalized : fallback;
};

export const fetchGenderOptions = async (basUrl) => {
  try {
    const res = await axios.get(`${basUrl}gender_options`);
    if (res.data?.Result !== "true") {
      throw new Error(res.data?.ResponseMsg || "Unable to load gender options");
    }

    return {
      personalGenderOptions: normalizeOptions(
        res.data.personal_gender_options,
        defaultGenderOptions,
      ),
      searchPreferenceOptions: normalizeOptions(
        res.data.search_preference_options,
        defaultSearchPreferenceOptions,
      ),
    };
  } catch (error) {
    return {
      personalGenderOptions: defaultGenderOptions,
      searchPreferenceOptions: defaultSearchPreferenceOptions,
    };
  }
};
